import  * as schema from 'yup';
import { SacSettingModel } from '../models/integrationSettings';
import { findRequiredFields } from '@/common/utils/validationHelper';

export const formSchema = schema.object<Partial<Record<keyof SacSettingModel, schema.AnySchema>>>({
	mainUrl: schema.string().matches(/^(ftp|http|https)?:\/\/[^ "]*$|^$/, 'Incorrect URL pattern'),
});
export const requiredFields = findRequiredFields('', formSchema.describe().fields);
